import type { ResolvedSection } from './termsSections'
import { TermsAndConditionsSection } from './TermsAndConditionsSection'

interface SectionedTermsAndConditionsContentProps {
    sections: ResolvedSection[]
    isCheckboxChecked: (checkboxId: string) => boolean
    onToggleCheckbox: (checkboxId: string) => void
}

/** New (uplifted) content: only the resolved sections (CHESS Sponsorship, FinClear Cash Hub,
 *  Monoova, SIX terms and conditions, FinClear Terms and Conditions, Identity verification)
 *  render here. Any policy resolveTermsSections could not map to a section (legacyPolicies) is
 *  intentionally not shown — useTermsAndConditionsSections reports an error instead, since an
 *  unmapped policy here means a new policy shipped on the backend without a matching section. */
export function SectionedTermsAndConditionsContent({
    sections,
    isCheckboxChecked,
    onToggleCheckbox,
}: SectionedTermsAndConditionsContentProps) {
    return (
        <div className="flex flex-col gap-10">
            {sections.map((section) => (
                <TermsAndConditionsSection
                    key={section.id}
                    title={section.title}
                    description={section.description}
                    checkboxes={section.checkboxes}
                    isCheckboxChecked={isCheckboxChecked}
                    onToggleCheckbox={onToggleCheckbox}
                />
            ))}
        </div>
    )
}
